document.addEventListener("alpine:init", () => {
  Alpine.data("deliveryEstimator", (options) => ({
    rates: [],
    pdp: options.pdp || false,
    cart: options.cart || false,
    variants: options.variants || [],
    monthsArr: options.monthsArr,
    daysArr: options.daysArr,
    days: options.days,
    hours: options.hours,
    minutes: options.minutes,
    userCountry: options.userCountry,
    currency: options.currency,
    permanentDomain: options.permanentDomain,

    init() {
      this.getDelRates();

      if (this.pdp) {
        window.addEventListener("variant-changed", (event) => {
          const newVariant = {
            quantity: 1,
            grams: event.detail.variant.weight || 0,
            price: event.detail.variant.price,
            variant_id: event.detail.variant.id,
          };

          this.variants = [newVariant];

          this.getDelRates();
        });
      } else if (this.cart) {
        this.$watch("rates", (newRates) => {
          console.log(this.getLowestPriceDelivery());
        });
      }
    },

    getDelRates() {
      var payload = {};
      payload = {
        rate: {
          origin: {
            country: Shopify.country,
          },
          destination: {
            country: this.userCountry,
          },
          items: this.variants,
          currency: this.currency,
          locale: Shopify.locale,
        },
      };

      fetch("https://delivery-estimator-production.herokuapp.com/rates.json", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          "X-Shopify-Shop-Domain": this.permanentDomain,
        },
      })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const data = JSON.parse(state);

          if (data.hasOwnProperty("error")) {
            this.rates = [];
          } else {
            this.rates = data.rates;
          }
        });
    },

    getShippingCountdown() {
      const currentTimestamp = new Date();
      const cutoffTimestamp = new Date();

      cutoffTimestamp.setHours(15, 0, 0, 0);

      let seconds = Math.floor((cutoffTimestamp - currentTimestamp) / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      let days = Math.floor(hours / 24);

      hours = hours - days * 24;
      minutes = minutes - days * 24 * 60 - hours * 60;
      seconds = seconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;

      let cutoffString = "";

      if (days == 1) cutoffString += `${days}${this.days[0]} `;

      if (days > 0) cutoffString += `${days}${this.days[1]} `;

      if (hours == 1) cutoffString += `${hours}${this.hours[0]} `;

      if (hours > 1) cutoffString += `${hours}${this.hours[1]} `;

      if (minutes == 1) cutoffString += `${minutes}${this.minutes[0]}`;

      if (minutes > 1) cutoffString += `${minutes}${this.minutes[1]}`;

      return cutoffString;
    },

    freeDeliveryAvailable() {
      return this.rates.some((rate) => rate.total_price === 0);
    },

    getEarliestDelivery() {
      if (!this.rates || this.rates.length === 0) {
        return null;
      }

      return this.rates.reduce((earliest, rate) => {
        const currentDate = new Date(rate.earliest_delivery);
        return !earliest || currentDate < earliest ? currentDate : earliest;
      }, null);
    },

    getItByDate() {
    if (!this.rates || this.rates.length === 0) return;

    const earliestDelivery = this.getEarliestDelivery();
    if (!earliestDelivery) return;

    let deliveryDate = new Date(earliestDelivery);
    
    // Add buffer days if deliveryBuffer is set and greater than 0
    const buffer = this.deliveryBuffer || (this.variants && this.variants[0] && this.variants[0].delivery_buffer) || 0;
    if (buffer > 0) {
      deliveryDate.setDate(deliveryDate.getDate() + buffer);
    }

    return `
      ${this.daysArr[deliveryDate.getDay()]} 
      ${deliveryDate.getDate()} 
      ${this.monthsArr[deliveryDate.getMonth()]}
    `;
  },

    getLowestPriceDelivery() {
      if (!this.rates || this.rates.length === 0) {
        return null;
      }

      return this.rates.reduce((cheapest, rate) => {
        return !cheapest || rate.total_price < cheapest.total_price
          ? rate
          : cheapest;
      }, null);
    },

    currencyConvert(price) {
      const moneyFormat = '{{ shop.money_format }}';
      const decimalPrice = price / 100;
      let amount = decimalPrice;
      if (this.currency != 'USD') {
        amount = Currency.convert(decimalPrice, 'USD', this.currency);
        amount = Math.ceil(amount);
      }
      return amount.toFixed(2);
    }
  }));
});